import { createSelector } from 'reselect';

// import { IUser } from 'types/user';
// import { formatAddress, getDefaultAvatarUrl } from 'utils';
import { RootState } from '../types';

export default class UserSelectors {
  static selectUser = (state: RootState) => state.user.data;

  // static getFullName = createSelector([UserSelectors.selectUser], (user) => `${user.firstName} ${user.lastName}`);

  static getUserId = createSelector([UserSelectors.selectUser], (user) => user.id);

  // static getBasicInfoSet = createSelector([UserSelectors.selectUser], (user) => {
  //   const firstName = user?.firstName || '';
  //   const lastName = user?.lastName || '';
  //   const defaultAvatar = getDefaultAvatarUrl(`${firstName} ${lastName}`);
  //   const avatarURL = user?.avatar?.pipeFrom || defaultAvatar;
  //   const smallAvatarURL = user?.avatar?.thumbnailPipeFrom || user?.avatar?.pipeFrom || defaultAvatar;
  //   const email = user?.email || '';
  //   let fullAddress = '';
  //   if (user.address1 || user.city || user.state || user.zip) {
  //     fullAddress = formatAddress((user as unknown) as IUser) || '';
  //   }

  //   return {
  //     firstName,
  //     lastName,
  //     avatarURL,
  //     smallAvatarURL,
  //     fullName: `${firstName} ${lastName}`,
  //     email,
  //     fullAddress,
  //   };
  // });

  // static getRole = createSelector([UserSelectors.selectUser], (user) => user.role || '');

  // static getUserStatus = createSelector([UserSelectors.selectUser], (user) => user.status || '');

  // static getUserCompanyRole = createSelector([UserSelectors.selectUser], (user) => user.companyRole || '');
}
